export default "__VITE_ASSET__DCnk2zZj__"